import React, { useState } from 'react'
import { Modal } from 'antd'
import { Scrollbars } from 'react-custom-scrollbars'
import { useDispatch } from 'react-redux'
import styles from './UploadJobControl.module.scss'
import { TaskList } from '..'
import { userActions } from '../../Redux/_actions'
import ModalInfo from '../modalInfo/ModalInfo'
import { useComponentLocale } from '../../hooks/useComponentLocale'

function UploadJobControl(props) {
	const [logs, setLogs] = useState({
		logVisible: false,
		logText: '',
	})
	const dispatch = useDispatch()

	const getLocale = useComponentLocale()
	const uploadLogLocale = getLocale({ component: 'uploadPage', section: 'upload_log' })
	const cancelLocale = getLocale({ component: 'common', section: 'cancel' })

	const onButtonStatusClicked = (job_id, status) => {
		dispatch(userActions.updateStatus(job_id, status))
	}

	const parseHandLog = (handLog) => {
		if (!handLog) {
			return
		}

		let parsedLog = []
		const contentLog = []

		try {
			parsedLog = JSON.parse(handLog)
		} catch (e) {
			return false
		}

		for (let i = 0; i < parsedLog.length; i++) {
			const lastLine = i === parsedLog.length - 2 ? <hr className={styles.divider} /> : ''
			contentLog.push({
				filename: parsedLog[i].fileName,
				total: parsedLog[i].total,
				added: parsedLog[i].parsed,
				stack: parsedLog[i].stack,
				spot: parsedLog[i].other,
				duplicates: parsedLog[i].duplicates,
				lastLine,
			})
		}

		return contentLog
	}

	return (
		<div className={styles.taskContainer}>
			<Modal
				title={uploadLogLocale}
				centered
				open={logs.logVisible}
				cancelText={cancelLocale}
				onOk={() => setLogs({ logVisible: false })}
				onCancel={() => setLogs({ logVisible: false })}
				cancelButtonProps={{ disabled: true }}
			>
				<div className={styles.logContainer}>
					<Scrollbars
						className={styles.scrollbar}
						renderThumbVertical={({ style, ...props }) => (
							<div {...props} style={{ ...style, backgroundColor: '#5a6268', borderRadius: '3px' }} />
						)}
					>
						{logs.logText && parseHandLog(logs.logText).map((info) => <ModalInfo info={info} key={info.filename} />)}
					</Scrollbars>
				</div>
			</Modal>
			<Scrollbars
				className={styles.scrollbar}
				renderThumbVertical={({ style, ...props }) => (
					<div {...props} style={{ ...style, backgroundColor: '#5a6268', borderRadius: '3px' }} />
				)}
			>
				<TaskList
					onButtonStatusClicked={(job_id, status) => onButtonStatusClicked(job_id, status)}
					taskList={props.taskList}
					openLog={(logText) => setLogs({ logVisible: true, logText })}
				/>
			</Scrollbars>
		</div>
	)
}

export default UploadJobControl
